import { SatellitePage } from "../SatellitePage";
import Sliderx from "../../utils/Sliderx";

export default class ScenesSatellitePage extends SatellitePage {
    private slider: Sliderx;

    public onInit(): void {
        this.slider = new Sliderx($('.sliderx', this.$el));

        const $items = $('.satellite-scenes__pages-item');

        $items.each((ix, el) => {
            const $item = $(el);

            const updateFunc = (ix: number) => {
                $item.removeClass('satellite-scenes__pages-item--selected-1 satellite-scenes__pages-item--selected-2');
                $item.addClass('satellite-scenes__pages-item--selected-' + ix);
            };

            const $btn1 = $('.satellite-scenes__pages-figure-nav-1', $item);
            const $btn2 = $('.satellite-scenes__pages-figure-nav-2', $item);

            $btn1.on('click', () => {
                updateFunc(1);
            });

            $btn2.on('click', () => {
                updateFunc(2);
            });

            updateFunc(1);
        });
    }
}
